import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const publisherTypeApi = generateNomenApi(`/nomen/publisher-type`);

export const publisherTypeOptions = generateNomenOptions('publisher-type', publisherTypeApi);
